import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import EventBus from 'diagram-js/lib/core/EventBus';

export class RenderElementHandler implements CommandHandler {

  constructor(private graphicsFactory, private elementRegistry, private eventBus: EventBus) {
  }

  postExecute(context): any {
    const element = context.element;
    context.rendered = this.renderElement(element);
  }

  private renderElement(element) {
    let rendered = false;
      const graphics = this.elementRegistry.getGraphics(element);

    if (!graphics) {
      const type = element.waypoints ? 'connection' : 'shape';
      const parentIndex = type === 'connection' ? 0 : undefined;
      element.businessObject.markedToBeRendered = true;
      // create graphics
      const gfx = this.graphicsFactory.create(type, element, parentIndex);
      this.elementRegistry.remove(element);
      this.elementRegistry.add(element, gfx, null);
      // update its visual
      this.graphicsFactory.update(type, element, gfx);
      this.eventBus.fire(type + '.added', { element: element, gfx: gfx });
      rendered = true;
    }
    return rendered;

  }
}
